export default __webpack_public_path__ + "f198aa695717eb8d7efb699938ef06c6.png";